export enum MarketTickerSortingOptions {
  GAINERS = 'gainers',
  LOSERS = 'losers',
  NEW = 'new',
  MARKET_CAP = 'marketCap',
  FAVOURITES = 'favourites',
  OWNED = 'owned',
}
